export default function CoralvilleStickyNav() {
  const links = [
    { label: "Service Area", href: "#service-area" },
    { label: "Services", href: "#services" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
  ];

  return (
    <nav className="sticky top-0 z-40 bg-white/95 backdrop-blur-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-14">
        <span className="font-bold text-[#1A365D] text-sm whitespace-nowrap">Coralville Passport</span>
        <div className="hidden md:flex items-center gap-6">
          {links.map((link) => (
            <a key={link.href} href={link.href} className="text-gray-500 hover:text-[#1A365D] text-sm font-medium transition-colors whitespace-nowrap">{link.label}</a>
          ))}
        </div>
        <a href="https://fastpassportcenter.com/checkout/" className="bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-xs px-4 py-2 rounded-md transition-all whitespace-nowrap">Start Now</a>
      </div>
    </nav>
  );
}